import { createAction, createAsyncActions } from './utils'

const reducer = 'SHOWINGS'

const openShowingsDialog = createAction(reducer, 'OPEN_SHOWINGS_DIALOG')

const {
  action: createShowings,
  actionSuccess: createShowingsSuccess,
  actionFail: createShowingsFail
} = createAsyncActions(reducer, 'CREATE')

const {
  action: setShowingApplicants,
  actionSuccess: setShowingApplicantsSuccess,
  actionFail: setShowingApplicantsFail
} = createAsyncActions(reducer, 'SET_SHOWING_APPLICANTS')

const {
  action: getShowings,
  actionSuccess: getShowingsSuccess,
  actionFail: getShowingsFail
} = createAsyncActions(reducer, 'GET')

const {
  action: getUserShowings,
  actionSuccess: getUserShowingsSuccess,
  actionFail: getUserShowingsFail
} = createAsyncActions(reducer, 'GET_USER_SHOWINGS')

const {
  action: getApartmentsShowings,
  actionSuccess: getApartmentsShowingsSuccess,
  actionFail: getApartmentsShowingsFail
} = createAsyncActions(reducer, 'GET_APARTMENTS_SHOWINGS')

const {
  action: getTimeslots,
  actionSuccess: getTimeslotsSuccess,
  actionFail: getTimeslotsFail
} = createAsyncActions(reducer, 'GET_TIMESLOTS')

const {
  action: denyReservable,
  actionSuccess: denyReservableSuccess,
  actionFail: denyReservableFail
} = createAsyncActions(reducer, 'DENY_RESERVABLE')

const {
  action: getReserveData,
  actionSuccess: getReserveDataSuccess,
  actionFail: getReserveDataFail
} = createAsyncActions(reducer, 'GET_RESERVE_DATA')

const {
  action: reserveShowing,
  actionSuccess: reserveShowingSuccess,
  actionFail: reserveShowingFail
} = createAsyncActions(reducer, 'RESERVE_SHOWING')

const {
  action: deleteShowing,
  actionSuccess: deleteShowingSuccess,
  actionFail: deleteShowingFail
} = createAsyncActions(reducer, 'DELETE_SHOWING')

const {
  action: addShowingToFieldArray,
  actionSuccess: addShowingToFieldArraySuccess,
  actionFail: addShowingToFieldArrayFail
} = createAsyncActions(reducer, 'ADD_SHOWING_TO_FIELD_ARRAY')

const {
  action: deleteShowingFromFieldArray,
  actionSuccess: deleteShowingFromFieldArraySuccess,
  actionFail: deleteShowingFromFieldArrayFail
} = createAsyncActions(reducer, 'DELETE_SHOWING_FROM_FIELD_ARRAY')

export {
  openShowingsDialog,
  createShowings,
  createShowingsSuccess,
  createShowingsFail,
  setShowingApplicants,
  setShowingApplicantsSuccess,
  setShowingApplicantsFail,
  getShowings,
  getShowingsSuccess,
  getShowingsFail,
  getUserShowings,
  getUserShowingsSuccess,
  getUserShowingsFail,
  getTimeslots,
  getTimeslotsSuccess,
  getTimeslotsFail,
  getReserveData,
  getReserveDataSuccess,
  getReserveDataFail,
  reserveShowing,
  reserveShowingSuccess,
  reserveShowingFail,
  deleteShowing,
  deleteShowingSuccess,
  deleteShowingFail,
  denyReservable,
  denyReservableSuccess,
  denyReservableFail,
  getApartmentsShowings,
  getApartmentsShowingsSuccess,
  getApartmentsShowingsFail,
  addShowingToFieldArray,
  addShowingToFieldArrayFail,
  addShowingToFieldArraySuccess,
  deleteShowingFromFieldArray,
  deleteShowingFromFieldArraySuccess,
  deleteShowingFromFieldArrayFail
}
